import ACTIONS from "../../constatnts"

export const apikey = (state = null, actions) => {
  const {type, payload} = actions

  switch (type) {
    case ACTIONS.SET_APIKEY:
      return payload
    default:
      return state
  }
}
